import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
import { ref } from 'vue';
import BaseButton from '@/templates/argon-core/BaseButton.vue';
const __default__ = {
  name: 'appg-btn-radio-group'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    _class: {
      type: String,
      default: ''
    },
    options: {
      type: [Array]
    },
    type: {
      type: [String]
    },
    modelValue: {
      type: [String, Number, Object, Boolean]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change', 'update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const value = ref(props.modelValue);

    // const model = computed(() => {
    //   get {
    //     return this.value;
    //   },
    //
    //   set(val) {
    //     if (this.disabled) return;
    //     this.$emit('change', val);
    //   }
    // })
    const emit = __emit;
    const fnSelect = val => {
      emit('update:modelValue', val);
      emit('change', val);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["btn-group-toggle", __props._class]),
        "data-toggle": "buttons"
      }, [Array.isArray(__props.options) ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(__props.options, (option, index) => {
        return _openBlock(), _createBlock(BaseButton, {
          key: `btn_${index}`,
          onClick: $event => fnSelect(option.value),
          type: __props.modelValue === option.value ? 'primary' : 'default',
          disabled: option.disabled
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(option.label), 1)]),
          _: 2
        }, 1032, ["onClick", "type", "disabled"]);
      }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(Object.keys(__props.options), (value, index) => {
        return _openBlock(), _createBlock(BaseButton, {
          key: `btn_${index}`,
          onClick: $event => fnSelect(value),
          type: __props.modelValue === value ? 'primary' : 'white'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.options[value]), 1)]),
          _: 2
        }, 1032, ["onClick", "type"]);
      }), 128))], 2);
    };
  }
});